// Third party libraries
import _ from 'lodash';
import React from "react";
import { connect } from "react-redux";

// Components
import ProPlanForm from './form'
import ProPlanOffers from '../offers'

// Redux
import { closeLoader, openLoader } from '../../../../../redux-store/loader';

// Models
import PaymentModel from '../../../../../data/models/payment/payment'

const defaultPlan = {
  name: "",
  logo: "",
  maxStudents: 3,
  monthlyPrice: 0,
  annualPrice: 0
}

class ProPlanEdit extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      plan: defaultPlan,
      loaded: false
    };

  }

  componentDidMount() {

    this.onGetData();
    
  }

  onGetData = async () => {

    try {

        this.props.openLoader();

        const planId = this.props.match.params.planId;

        if(planId != 'new'){
          
          const plan = await PaymentModel.getProPlanById(planId);

          if(plan.data) {

            this.setState({
              plan: plan.data,
              loaded: true
            });

          } 

        }
    } catch (error) {

      console.error("Error onGetProPlan", error);
        
    } finally {
    
      this.props.closeLoader();
      this.setState({ loaded: true });
    
    }

  }

  render() {

    const { plan, loaded } = this.state;

    if (!loaded) {
      return <div>Cargando plan...</div>; 
    }

    const isNewPlan = this.props.match.params.planId === 'new';

    return !_.isEmpty(plan) && (
      <React.Fragment>
        <ProPlanForm 
          initialValues={ plan } 
          history={ this.props.history } 
          {...this.props} 
        />
        {
          !isNewPlan && <ProPlanOffers plan={ plan } {...this.props} onSubmitSuccess={this.onGetData} />
        }
      </React.Fragment>
    )
  }
}

export default connect(null, { openLoader, closeLoader })(ProPlanEdit);